<template>
    <div class="page">
        <div class="top">
            <h3>追溯小票</h3>
        </div>
        <div class="market-message">
            <div class="market-name">市场名称: <span>{{ ticketInfo.market_name }}</span></div>
            <div class="booth-name">摊位号: <span>{{ ticketInfo.boothsn }}</span></div>
            <div class="business-name">商户名称: <span>{{ ticketInfo.merchant_name }}</span></div>
            <div class="form-num">交易单号: <span>{{ ticketInfo.order_sn }}</span></div>
            <div class="ship-time">交易时间: <span>{{ timestampToTime(ticketInfo.pay_time) }}</span></div>
        </div>
        <div class="box">
            <div class="goods" v-for="(item, index) in ticketInfo.pro_list" :key="index">
                <div class="goods-name">商品名称: <span>{{ item.product_name }}</span></div>
                <div class="row">
                    <div class="goods-price"> 商品单价: <span>{{ item.price + ' 元/千克' }}</span></div>
                    <div class="goods-weight">商品重量: <span>{{ item.tare_weight + ' 千克' }}</span></div>
                </div>
                <div class="row">
                    <div class="goods-num">商品金额: <span>{{ item.total_price + ' 元' || 0.00 }}</span></div>
                    <div class="zhuisu">
                        <p @touchstart="toZhuiSu(item)">商品追溯</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="price-num">
            <div>合计金额:
                <span v-if="ticketInfo.total_amount">{{ ticketInfo.total_amount + ' 元' }}</span>
                <span v-else>0.00 元</span>
            </div>
        </div>
        <div class="appraise">
            <div class="appraise-title">
                商户点评
            </div>
            <div class="star">
                <div class="order-evaluation">
                    <div class="block">
                        <van-rate v-model="subData.score" allow-half void-icon="star" size="30" void-color="#eee" />
                    </div>
                    <div class="order-evaluation-checkbox">
                        <div class="evaluation_row">
                            <div class="e_btn" data-id="1" data-text="态度好" @click="tabTdSelect"
                                :class="tbObj.tabTdIndex == 1 ? 'goodTab' : ''">态度好</div>
                            <div class="e_btn" data-id="3" data-text="品质好" @click="tabPzSelect"
                                :class="tbObj.tabPzIndex == 3 ? 'goodTab' : ''">品质好</div>
                            <div class="e_btn" data-id="5" data-text="划算" @click="tabHsSelect"
                                :class="tbObj.tabHsIndex == 5 ? 'goodTab' : ''">划算</div>
                            <div class="e_btn" data-id="7" data-text="新鲜" @click="tabXxSelect"
                                :class="tbObj.tabXxIndex == 7 ? 'goodTab' : ''">新鲜</div>
                        </div>
                        <div class="evaluation_row">
                            <div class="e_btn" data-id="2" data-text="态度差" @click="tabTdSelect"
                                :class="tbObj.tabTdIndex == 2 ? 'badTab' : ''">态度差</div>
                            <div class="e_btn" data-id="4" data-text="品质差" @click="tabPzSelect"
                                :class="tbObj.tabPzIndex == 4 ? 'badTab' : ''">品质差</div>
                            <div class="e_btn" data-id="6" data-text="不划算" @click="tabHsSelect"
                                :class="tbObj.tabHsIndex == 6 ? 'badTab' : ''">不划算</div>
                            <div class="e_btn" data-id="8" data-text="不新鲜" @click="tabXxSelect"
                                :class="tbObj.tabXxIndex == 8 ? 'badTab' : ''">不新鲜</div>
                        </div>
                    </div>
                    <div class="liuyan_content">
                        <van-field v-model="subData.content" rows="5" autosize type="textarea" maxlength="100"
                            placeholder="请输入您宝贵的评价！" show-word-limit style="background-color: #eee;" />
                    </div>
                    <div class="lx_content">
                        <van-field v-model="subData.customer" required border label="联系人" placeholder="请输入联系人" />
                        <van-field v-model="subData.mobile" required border type="tel" label="联系方式"
                            placeholder="请输入联系方式" />
                    </div>
                    <div class="img_content">
                        <div class="title"><span>*</span>图片</div>
                        <van-uploader :max-count="3" v-model="fileList" :after-read="afterRead" upload-text="评价图片" />
                    </div>
                    <div class="sub_btn">
                        <div class="btn" @touchstart="handleSubmit">提 交</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fileList: [],
            keys: "",
            ticketInfo: "",
            subData: {
                market_id: "",
                mid: "",
                score: 5,
                content: "",
                customer: "",
                mobile: "",
                img_url: ""
            },
            tbObj: {
                tabTdText: "",
                tabTdIndex: "",
                tabPzText: "",
                tabPzIndex: "",
                tabHsText: "",
                tabHsIndex: "",
                tabXxText: "",
                tabXxIndex: "",
            }
        }
    },
    created() {
        this.getParameterByName("keys")
        this.keys = this.getParameterByName("keys")
        this.getTicketInfo()
    },
    mounted() { },
    methods: {
        // 解析URL
        getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            //匹配所有符合条件的，并取最后一个
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", 'g');
            var results = url.match(regex);
            var tempResults = results != null && results[results.length - 1] != undefined ? results[results.length - 1] : '';
            var finalResults = regex.exec(tempResults);
            if (!finalResults) return "";
            if (!finalResults[2]) return '';
            return decodeURIComponent(finalResults[2].replace(/\+/g, " "));
        },
        // 封装请求列表数据的方法
        async getTicketInfo() {
            // 调用 axios 的 get 方法，请求列表数据
            const { data: res } = await this.$https.post('/market/ticket/get-ticket-info', { order_sn: this.keys })
            // 只要请求回来的数据，在页面渲染期间要用到，则必须转存到 data 中
            if (res.resultCode == 1) {
                this.ticketInfo = res.resultInfo
                this.subData.market_id = res.resultInfo.market_id
                this.subData.mid = res.resultInfo.mid
            }
        },
        timestampToTime(timestamp) {
            if (timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate();
                D = D < 10 ? '0' + D : D;
                var h = date.getHours();
                h = h < 10 ? '0' + h : h;
                var m = date.getMinutes();
                m = m < 10 ? '0' + m : m;
                var s = date.getSeconds();
                s = s < 10 ? '0' + s : s;
                return Y + M + D + ' ' + h + ':' + m + ':' + s;
            } else {
                return "暂无"
            }
        },
        toZhuiSu(item) {
            this.$router.push({
                path: "/zhuisu",
                query: {
                    mid: this.ticketInfo.mid,
                    keys: this.keys,
                    goodsname: item.product_name,
                    market_id: this.ticketInfo.market_id,
                    boothsn: this.ticketInfo.boothsn,
                    merchant_name: this.ticketInfo.merchant_name,
                },
            });
        },
        // 图片上传
        afterRead(file) {
            console.log(file);
        },
        // 提交
        async handleSubmit() {
            if (!this.subData.content) {
                this.$notify({ type: 'warning', message: '请输入市场评价！' });
            } else if (!this.subData.customer) {
                this.$notify({ type: 'warning', message: '请输入您的姓名！' });
            } else if (!this.subData.mobile) {
                this.$notify({ type: 'warning', message: '请输入您的联系方式！' });
            } else {
                this.subData.img_url = JSON.stringify(this.fileList);
                const { data: res } = await this.$https.post('/market/ticket/add-ping-jia', this.subData)
                // 只要请求回来的数据，在页面渲染期间要用到，则必须转存到 data 中
                if (res.resultCode == 1) {
                    this.fileList = [];
                    this.subData = {
                        market_id: "",
                        mid: "",
                        score: 5,
                        content: "",
                        customer: "",
                        mobile: "",
                        img_url: ""
                    };
                    this.$notify({ type: 'success', message: res.message });
                } else {
                    this.$notify({ type: 'danger', message: res.message });
                }
            }

        },
        // tab选择
        tabTdSelect(e) {
            this.tbObj.tabTdIndex = e.target.dataset.id;
            this.tbObj.tabTdText = e.target.dataset.text + "，";
            if (this.tbObj.tabTdText || this.tbObj.tabPzText || this.tbObj.tabHsText || this.tbObj.tabXxText) {
                this.subData.content = this.tbObj.tabTdText + this.tbObj.tabPzText + this.tbObj.tabHsText + this.tbObj.tabXxText;
            }
        },
        tabPzSelect(e) {
            this.tbObj.tabPzIndex = e.target.dataset.id;
            this.tbObj.tabPzText = e.target.dataset.text + "，";
            if (this.tbObj.tabTdText || this.tbObj.tabPzText || this.tbObj.tabHsText || this.tbObj.tabXxText) {
                this.subData.content = this.tbObj.tabTdText + this.tbObj.tabPzText + this.tbObj.tabHsText + this.tbObj.tabXxText;
            }
        },
        tabHsSelect(e) {
            this.tbObj.tabHsIndex = e.target.dataset.id;
            this.tbObj.tabHsText = e.target.dataset.text + "，";
            if (this.tbObj.tabTdText || this.tbObj.tabPzText || this.tbObj.tabHsText || this.tbObj.tabXxText) {
                this.subData.content = this.tbObj.tabTdText + this.tbObj.tabPzText + this.tbObj.tabHsText + this.tbObj.tabXxText;
            }
        },
        tabXxSelect(e) {
            this.tbObj.tabXxIndex = e.target.dataset.id;
            this.tbObj.tabXxText = e.target.dataset.text + "，";
            if (this.tbObj.tabTdText || this.tbObj.tabPzText || this.tbObj.tabHsText || this.tbObj.tabXxText) {
                this.subData.content = this.tbObj.tabTdText + this.tbObj.tabPzText + this.tbObj.tabHsText + this.tbObj.tabXxText;
            }
        }
    },
}
</script>

<style lang="less" scoped>
.page {
    width: 100vw;
    min-height: 100%;
    height: fit-content;
    background-color: #f6f6f6 !important;
    padding-bottom: .5333rem;
}

.top {
    width: 100%;
    height: 1.28rem;
    text-align: center;
    background-color: #fff !important;
}

.top h3 {
    font-size: .64rem;
    line-height: 1.28rem;
    font-weight: 700;
    color: #313f4c;
}

.market-message {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 94%;
    height: 5rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
    box-sizing: border-box;
    border-radius: .1067rem;
    padding: .2667rem 0;
}

.market-message>div {
    flex: 1;
    line-height: .8907rem;
    font-size: .4267rem;
    padding: 0 .2133rem;
    color: #3a3a3a;
}

.market-message span {
    float: right;
    font-size: .4267rem;
}

.goods {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 94%;
    height: 3rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
    box-sizing: border-box;
    border-radius: .1067rem;
    padding: .2667rem 0;
}

.goods>div {
    flex: 1;
    line-height: .8533rem;
    font-size: .3733rem;
    padding: 0 .2133rem;
    color: #3a3a3a;
}

.row>div {
    float: left;
    width: 50%;
    overflow: hidden;
}

.row>div:nth-child(2) {
    float: right;
}

.goods span {
    font-size: .3733rem;
}

.goods div p {
    text-align: center;
    width: 4rem;
    text-align: center !important;
    height: .8rem;
    background-color: #36d078;
    color: #fff;
    font-size: .4267rem;
    border-radius: .16rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.price-num {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 94%;
    height: 1.0667rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
    box-sizing: border-box;
    border-radius: .1067rem;
    padding: .1067rem 0;
}

.price-num>div {
    flex: 1;
    line-height: 1.0667rem;
    font-size: .48rem;
    padding: 0 .2133rem;
    color: #3a3a3a;
}

.price-num span {
    float: right;
    font-size: .48rem;
    padding-right: .2667rem;
}

.appraise {
    width: 94%;
    height: 17rem;
    margin-left: 3%;
    background-color: #fff;
    margin-top: .32rem;
    box-sizing: border-box;
    border-radius: .1067rem;
    padding: .1067rem 0;
    box-sizing: border-box;
}

.appraise-title {
    margin-top: .2rem;
    margin-left: .2133rem;
    font-size: .48rem;
    color: #000;
}

.block {
    text-align: center;
    width: 100%;
    margin-bottom: .2667rem;
}

.block span img {
    width: .8rem;
    height: .8rem;
}

.order-evaluation {
    background: #fff;
    z-index: 200;

}

.order-evaluation {
    padding: .4rem 0;
    padding-top: .2rem;
}


.evaluation_row {
    width: 100%;
    height: 1.25rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    padding: 0 .6rem;
}

.e_btn {
    width: 1.75rem;
    height: .8rem;
    border: .0267rem solid #8f8f8f;
    border-radius: .1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .3733rem;
}

.liuyan_content {
    width: 94%;
    margin-left: 3%;
    margin-top: .2667rem;
    box-sizing: border-box;
    overflow: hidden;
}

.img_content {
    .title {
        width: 100%;
        height: .64rem;
        font-size: .3733rem;
        color: #000;
        margin-bottom: .2667rem;
        margin-left: -0.0533rem;
        border-top: .0267rem solid #f7f7fa;

        span {
            color: red;
            margin-right: .0533rem;
            font-size: .4267rem;
        }
    }

    width: 94%;
    margin-left: 3%;
    // margin-top: .2667rem;
    box-sizing: border-box;
    overflow: hidden;
    // background-color: #eee;
}

.sub_btn {
    width: 100%;
    height: 1.3333rem;
    // background-color: pink;
    margin-top: .5333rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
        width: 3rem;
        height: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #31b158;
        color: #fff;
        font-weight: 600;
        font-size: .4267rem;
        border-radius: .1333rem;
    }
}

.goodTab {
    color: #31b158 !important;
    border: .0267rem solid #31b158 !important;
}

.badTab {
    color: red !important;
    border: .0267rem solid red !important;
}

/deep/ .van-cell__title {
    color: #000 !important;
    font-size: .3733rem !important;
}
</style>